import React, { useState, Fragment } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { useTheme } from '@mui/material/styles';
import { Stack, Typography } from '@mui/material';
import utils from 'components/utils';

const HeaderPage = props => {
	const theme = useTheme();
	const translate = utils.useI18N();

	return (
		<Stack
			direction={{ xs: 'row', md: 'row', sm: 'row' }}
			justifyContent="flex-stat"
			alignItems="flex-start"
			spacing={1}
			variant="wrapperColor"
		>
			<Typography variant="titlePage">{translate('kit.kit')}</Typography>
		</Stack>
	);
};

export default HeaderPage;
